import { Modal as ModalMui } from '@mui/base/Modal';
import cx from 'classnames';
import { forwardRef, ReactNode } from 'react';

import styles from './styles.scss';

interface ModalProps {
  isClose: boolean;
  setIsClose: (isClose: boolean) => void;
  children: ReactNode;
}

export const Modal = ({ isClose, setIsClose, children }: ModalProps) => {
  return (
    <ModalMui
      open={!isClose}
      onClose={() => setIsClose(true)}
      slots={{ backdrop: Backdrop }}
      className={styles.baseModal}
    >
      <div className={styles.modalContent}>{children}</div>
    </ModalMui>
  );
};

interface BackdropProps {
  open?: boolean;
  className: string;
  // `ownerState` is injected by MUI for styling, but it should not
  // be forwarded to the underlying DOM element.
  ownerState?: unknown;
}

const Backdrop = forwardRef<HTMLDivElement, BackdropProps>((props, ref) => {
  const { open, className, ownerState, ...other } = props;

  return (
    <div
      className={cx(styles.backdrop, className, { 'base-Backdrop-open': open })}
      ref={ref}
      {...other}
    />
  );
});
